import React, { useState } from "react";
import { toast } from "react-toastify";
import GradientButton from "../../UI/GradientButton";
import InputField from "../../../auth/InputField";
import "./index.scss";

interface AddEmailProps {
  handleSend: (phoneNumber: string) => void;
  loading?: boolean;
}

const AddEmail: React.FC<AddEmailProps> = ({ handleSend, loading }) => {
  const [email, setEmail] = useState<string>("");

  const sendOTP = () => {
    if (!email) {
      toast.error("Please enter valid email");
      return;
    }
    handleSend(email);
  };

  return (
    <div className="add-email-container">
      <div>
        <img src="/assets/images/user-email.svg" alt="" />
      </div>

      <h1 className="title">Enter email to continue</h1>

      <div className="field-container">
        <label>Email</label>
        <InputField
          type="tel"
          placeholder="example@gmail.com"
          className="phone-input"
          disabled={loading}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <p className="note">
        Please verify your email to make purchases and keep your account safe.
      </p>

      <GradientButton loading={loading} onClick={sendOTP}>
        Continue
      </GradientButton>
    </div>
  );
};

export default AddEmail;
